import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const VerifyEmailHintPage = () => {
  const [resending, setResending] = useState(false);
  const email = localStorage.getItem('partner_email') || '';

  const handleResend = async () => {
    if (!email) {
      alert('Keine E-Mail-Adresse gefunden');
      return;
    }
    
    setResending(true);
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      alert('Neuer Bestätigungslink wurde gesendet (falls E-Mail existiert)');
    } catch (err) {
      alert('Fehler beim Versenden');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6 lg:px-8">
          <div className="bg-white border border-gray-200 rounded-3xl p-12 shadow-lg text-center">
            <div className="w-20 h-20 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-brand-green/15">
              <Mail className="w-10 h-10 text-brand-green" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Bitte E-Mail bestätigen
            </h1>
            <p className="text-xl text-gray-600 mb-6">
              Wir haben dir einen Bestätigungslink gesendet.
            </p>
            <p className="text-gray-600 mb-10">
              Nach der Bestätigung geht's ins Onboarding.
            </p>
            
            <Button
              onClick={handleResend}
              disabled={resending}
              variant="outline"
              className="border-2 border-gray-300"
            >
              {resending ? 'Wird gesendet...' : 'Neuen Link anfordern'}
            </Button>
            
            <p className="text-sm text-gray-500 mt-6">
              Bitte prüfe auch deinen Spam-Ordner.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default VerifyEmailHintPage;